/**
 * @generated SignedSource<<9be03d1dfe6b4af52500b302f35edc5b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReturnPolicy_sku$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDetailReturnPolicy_sku";
};
export type PdpSharedDetailReturnPolicy_sku$key = {
  readonly " $data"?: PdpSharedDetailReturnPolicy_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReturnPolicy_sku",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "a2b1d354625c580c6152b7fae6315161";

export default node;
